module.exports = __webpack_public_path__ + "static/media/AngryFACE.ce97a2ba.png";